import { Button, Fade } from "@mui/material";
import { Box, Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import Default from "../../images/imagebgsection.jpeg";
import { Link as RouterLink } from "react-router-dom";

const ImageBGSection = ({ content, loading }) => {
    
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const element = document.getElementById("bg-square");
            if (element) {
                const rect = element.getBoundingClientRect();
                const visible = rect.top < window.innerHeight && rect.bottom >= 0;
                setIsVisible(true);
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, []);

    return(
        <>
            {content?
                <Fade in={true} timeout={1000}>
                    <Container maxWidth='xl'>
                        <Box
                            id="bg-square"
                            sx={{
                                // width: {
                                //     xs: "100%",
                                //     md: "90%",
                                // },
                                //margin: "auto",
                                padding: "1rem 0 3rem 0",
                                backgroundImage: content.bg_image? `url(${content.bg_image})` : 'url('+Default+')',
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                textAlign: "center",
                                color: "#ffffff",
                                position: "relative",
                                mt:'3rem',
                            }}
                        >
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: content.bg_image ? "rgba(13,96,168,0.9)" : "rgba(13,96,168,0)",
                                    mixBlendMode: "multiply",
                                    zIndex: "1",
                                }}
                            />
                            <Fade in={true} timeout={1500}>
                                <h4
                                    style={{
                                        color: "#ffffff",
                                        textAlign: "center",
                                        fontSize: "1.6rem",
                                        fontWeight: "600",
                                        position: "relative",
                                        zIndex: "2",
                                    }}
                                >
                                    {content.bg_title}
                                </h4>
                            </Fade>
                            <Fade in={true} timeout={2000}>
                                <Box
                                    sx={{
                                        fontSize: "18px",
                                        width: "80%",
                                        margin: "auto",
                                        position: "relative",
                                        zIndex: "2",
                                        maxWidth: "760px",
                                    }}
                                    dangerouslySetInnerHTML={{ __html: content.bg_content }}
                                />
                            </Fade>
                            <Fade in={true} timeout={2000}>
                                <Button
                                    sx={{
                                        backgroundColor: "#E9531C",
                                        borderRadius: "50px",
                                        color: "#ffffff",
                                        padding: "0.5rem 1rem",
                                        position: "relative",
                                        zIndex: "2",
                                        fontSize: "1rem",
                                        fontWeight: "600",
                                        marginTop: "20px",
                                        '&:hover': {
                                            backgroundColor: "#0C5EAA",
                                        },
                                    }}
                                    component={RouterLink}
                                    to={content.bg_link}
                                    target={content?.bg_link.includes("s2partnership.bamboohr.com") ? "_blank" : "_self"}

                                >
                                    {content.bg_button}
                                </Button>
                            </Fade>
                        </Box>
                    </Container>
                </Fade>
            :null}
        </>
    );
};

export default ImageBGSection;